<template>
	<modal
		size="medium"
		@close="close">
		<template slot="header">
			<h3>
				<i class="material-icons">payment</i>
				<span>{{ $t('Product Payments') }}</span>
			</h3>
		</template>
		<template slot="body">
			<div class="alert alert-warning d-flex align-items-center">
				<span>{{ $t('Please be aware, that this settings will override all payment settings on the selected products.') }}</span>
			</div>
			<product-payments
				@change="onProductPropertiesChange"
			/>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-light"
				@click="close">
				{{ $t('Close') }}
			</button>
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isSubmitting }"
				:disabled="!isFormValid"
				@click="submit">
				{{ $t('Submit') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import products from '@/api/products';
import ProductPayments from '@/components/ProductPayments.vue';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'ProductPaymentsModal',
	components: {
		Modal,
		ProductPayments,
	},
	props: {
		productIds: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			productProperties: {},
			isSubmitting: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		submit() {
			this.isSubmitting = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Bulk Update Product Shipping',
					text: message,
				});
				this.close();
				this.isSubmitting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Bulk Update Product Shipping',
					text: message,
				});
				this.isSubmitting = false;
			};
			products.bulkUpdate(this.params, callback, errorCallback);
		},
		onProductPropertiesChange(properties) {
			this.productProperties = (properties);
		},
	},
	computed: {
		isFormValid() {
			const valids = [];

			// validitiy payments
			if (this.productProperties && this.productProperties.payments && this.productProperties.payments.length > 0) {
				valids[0] = true;
			} else {
				valids[0] = false;
			}

			// validity payment cod , cod courier  minimum 1 selected
			if (this.productProperties && this.productProperties.payments && this.productProperties.payments.length > 0) {
				// check cod payment
				const hasCodPayment = this.productProperties.payments.findIndex(({ key }) => key === 'cod') !== -1;
				const isIncludeShipping = this.productProperties.shipping && this.productProperties.shipping.cod && this.productProperties.shipping.cod.includeShipping;
				// check hasCodPayment && include shipping
				if (hasCodPayment && isIncludeShipping) {
					if (this.productProperties.shipping && this.productProperties.shipping.cod_couriers && this.productProperties.shipping.cod_couriers.length > 0) {
						valids[1] = true;
					} else {
						valids[1] = false;
					}
				} else {
					valids[1] = true;
				}

				// check instant payment
				const hasInstantPayment = this.productProperties.payments.findIndex(({ key }) => key === 'instant') !== -1;
				// check instant channel
				if (hasInstantPayment) {
					if (this.productProperties.payment_channels && this.productProperties.payment_channels.length > 0) {
						valids[2] = true;
					} else {
						valids[2] = false;
					}
				} else {
					valids[2] = true;
				}
			}

			const isValid = valids.filter(value => !value).length === 0;
			return isValid;
		},
		params() {
			const params = Object.assign({}, this.productProperties);

			const productIds = JSON.stringify(this.productIds);
			const selectedPayments = this?.productProperties?.payments ?? [];
			const payments = selectedPayments.map(({ key }) => key);
			const paymentsJson = JSON.stringify(payments);
			const paymentChannelsJson = JSON.stringify(params.payment_channels);
			const paymentChannelsDescJson = JSON.stringify(params.payment_channels_descriptions);
			const paymentMethodsDescJson = JSON.stringify(params.payment_methods_descriptions);
			const shippingJson = JSON.stringify(params.shipping);

			params.product_ids = productIds;
			params.payments = paymentsJson;
			params.payment_methods_descriptions = paymentMethodsDescJson;
			params.payment_channels = paymentChannelsJson;
			params.payment_channels_descriptions = paymentChannelsDescJson;
			params.shipping = shippingJson;

			return params;
		},
	},
};
</script>
